export class ListMenuOption {
    ID: number;
    Name: string;
    Icon: string;
    IconOutlined: boolean;
    Disabled: boolean;
    ItemApiID?: number;
    Children?: ListMenuOption[];
}